import { secondaryTheme } from '@repo/ui/components/Buttons';
import { themeStyle } from '@repo/ui/theming';

const inviteShareButtonTheme = {
  ...secondaryTheme,
  backgroundColor: themeStyle.varBackgroundBase,
  borderColor: themeStyle.varInkLight,
  height: '53px',
};

export const inviteShareMobileButtonTheme = {
  height: '30px',
};

export const inviteShareWhatsappButtonTheme = {
  ...inviteShareButtonTheme,
  iconColor: '#25D366',
  iconActiveColor: '#25D366',
};

export const inviteShareEmailButtonTheme = {
  ...inviteShareButtonTheme,
  iconColor: themeStyle.varInkMedium,
  iconActiveColor: themeStyle.varInkMedium,
};
